import type { RuleSet } from 'styled-components';
import styled from 'styled-components';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import {
  LastMinuteDealsBadgeContainer,
  TextContainer,
} from '@/app/common/components/Promotions/LastMinuteDealsBadge/styled.ts';
import { PeriodicPromotion } from '@/app/common/components/Promotions/LastMinuteDealsBadge/PeriodicPromotion';

const BadgeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 4px;
`;

const LastMinuteDealsBadge = (
  props: {
    fontPreset?: RuleSet<object>;
    iconSize?: number;
    skipPeriodicPromotion?: boolean;
  } & React.HTMLAttributes<HTMLDivElement>
) => {
  const { fontPreset, iconSize = 16, skipPeriodicPromotion = false, ...rest } = props;
  const { localization } = usePageWrapperData();
  const { t } = useTranslation();

  const { imageBasePath } = localization;
  const icon = `${imageBasePath}icons/last_minute_deals_underline.svg`;

  return (
    <BadgeContainer {...rest}>
      <LastMinuteDealsBadgeContainer>
        <img src={`${imageBasePath}icons/last_minute_deals_rebrand.svg`} alt="" width={iconSize} height={iconSize} />
        <TextContainer
          dangerouslySetInnerHTML={{ __html: t('vacation.oss.last_minute_deals.label_HTML') }}
          $icon={icon}
          $color={'#251E2D'}
          $preset={fontPreset}
        />
      </LastMinuteDealsBadgeContainer>
      {!skipPeriodicPromotion && <PeriodicPromotion />}
    </BadgeContainer>
  );
};

export default LastMinuteDealsBadge;
